import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { getDefaultThemeName } from './common';
import { ThemeName } from './schemas';

interface UsersState {
  themeName: ThemeName;
  /**
   * True from the moment a global filter mutation is dispatched until the
   * subsequent `getUserInfo` refetch has settled **and** the router has
   * navigated to the correct search params for the current route.
   *
   * Used by `useGlobalFilterKeys` to gate all downstream queries so they
   * fire exactly once with the final, post-navigation parameters.
   */
  globalFilterChangePending: boolean;
}

const initialState: UsersState = {
  themeName: getDefaultThemeName(),
  globalFilterChangePending: false,
};

export const usersSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserThemeName: (state, action: PayloadAction<ThemeName>) => {
      state.themeName = action.payload;
    },

    setGlobalFilterChangePending: (state, action: PayloadAction<boolean>) => {
      state.globalFilterChangePending = action.payload;
    },
  },
});

export const userThemeNameSelector = (state: { user: UsersState }) =>
  state.user.themeName;

export const globalFilterChangePendingSelector = (state: {
  user: UsersState;
}) => state.user.globalFilterChangePending;

export const { setUserThemeName, setGlobalFilterChangePending } =
  usersSlice.actions;

export default usersSlice.reducer;
